import { tableSearchApiRowsPerPageOptions } from '@/search-for-retail/constants';
import { BusinessObjectiveOption, ModelTypeOption } from '@/search-for-retail/recs-model/constants/recs-model-type.constants';
export const REF_APP_SLICE_KEY = 'refApp';
export const ACTION_PREFIX = 'REF_APP:';
export const DEFAULT_ROWS_PER_PAGE = tableSearchApiRowsPerPageOptions[0];
export const REF_APP_STATE_PATHS_TO_PERSIST_IN_SESSION_STORAGE = [
    `${REF_APP_SLICE_KEY}.requestOptions.visitorId`,
];
export const START_DEPTH_FOR_COLLAPSING = 1;
export var EvaluationType;
(function (EvaluationType) {
    EvaluationType["Query"] = "query";
    EvaluationType["Recommendations"] = "recommendations";
    EvaluationType["Browse"] = "browse";
})(EvaluationType || (EvaluationType = {}));
export const EVALUATE_PARSE_JSON_ERROR = 'EVALUATE_PARSE_JSON_ERROR';
export const ModelTypeLocalizationKeyMap = {
    [ModelTypeOption.RecentlyViewed]: 'RECS_MODEL_STEP_MODEL_TYPE_RECENTLY_VIEWED',
    [ModelTypeOption.RecommendedForYou]: 'RECS_MODEL_STEP_MODEL_TYPE_RECOMMENDED_FOR_YOU',
    [ModelTypeOption.FrequentlyBoughtTogether]: 'RECS_MODEL_STEP_MODEL_TYPE_FREQUENTLY_BOUGHT_TOGETHER',
    [ModelTypeOption.BuyItAgain]: 'RECS_MODEL_STEP_MODEL_TYPE_BUY_IT_AGAIN',
    [ModelTypeOption.OthersYouMayLike]: 'RECS_MODEL_STEP_MODEL_TYPE_OTHERS_YOU_MAY_LIKE',
    [ModelTypeOption.SimilarItems]: 'RECS_MODEL_STEP_MODEL_TYPE_SIMILAR_ITEMS',
    [ModelTypeOption.OnSaleItems]: 'RECS_MODEL_STEP_MODEL_TYPE_ON_SALE',
    // API supported but not yet implemented in UI
    // [ModelTypeOption.PageOptimization]: 'RECS_MODEL_STEP_MODEL_TYPE_PAGE_OPTIMIZATION',
};
export const BusinessTypeLocalizationKeyMap = {
    [BusinessObjectiveOption.ClickThroughRate]: 'RECS_MODEL_BUSINESS_OBJECTIVE_CLICK_THROUGH_RATE',
    [BusinessObjectiveOption.ConversionRate]: 'RECS_MODEL_BUSINESS_OBJECTIVE_CONVERSION_RATE',
    [BusinessObjectiveOption.RevenuePerSession]: 'RECS_MODEL_BUSINESS_OBJECTIVE_REVENUE_PER_SESSION',
};
export const getModelTypeLocalizationKey = (modelType) => ModelTypeLocalizationKeyMap[modelType] || 'NO_MODEL_TYPE';
export const getBusinessTypeLocalizationKey = (businessType) => BusinessTypeLocalizationKeyMap[businessType] || 'NO_BUSINESS_OBJECTIVE';
